export default {"src":"/_next/static/media/linkedin.0e669a17.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};